/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-01 13:44:01
 * @Description: 
 */
import { InputNumber, Popover, Slider } from "antd"
import { autorun } from "mobx"
import React from "react"
import FTAnalytic from "src/analyze/FTAnalytic"
import { CanvasLoading, IconArrawLeft, IconArrawRight, IconClose, IconCompare, IconHDNew, IconVip } from "src/assets"
import FTButton from "src/components/FTButton/FTButton"
import FTDownloadSize from "src/components/FTDownloadSize/FTDownloadSize"
import FTimageCompare from "src/components/FTImageOperate/FTimageCompare"
import FTimageHD from "src/components/FTImageOperate/FTimageHD"
import FTWatermark from "src/components/FTWatermark/FTWatermark"
import FTCanvasStore from "src/store/FTCanvasStore"
import FTImageStore from "src/store/FTImageStore"
import FTUserStore from "src/store/FTUserStore"
import { Size } from "src/store/types"
import utils from "src/utils"
import FTLang from "src/utils/FTLang"
import "./FTCanvas.scss"
import FTCanvasPanel from "./FTCanvasPanel"

interface IState {
  showPanel: boolean,
  loading: boolean,
  showDownload: boolean,
  showWaterMark: boolean,
  currentIntensity: number,
  smallSize: Size,
  largerSize: Size,
  waterMarkText: string
  isMobile: boolean
}
class FTCanvas extends React.Component<{}, IState> {
  canvasRef: HTMLDivElement | null = null
  waterCloseRef:HTMLDivElement|null=null
  canvasContainRef: HTMLDivElement | null = null
  imageBlandMaskTimer: any
  observe:any
  hasCompare:boolean=false
  handelWaterClose:any=null
  state: IState = {
    loading: true, // 图片加载loading
    showPanel: false,
    showDownload: false,
    showWaterMark: false,
    currentIntensity: FTImageStore.currentIntensity,
    smallSize: {
      width: 0,
      height: 0
    },
    largerSize: {
      width: 0,
      height: 0
    },
    waterMarkText: "goart_remove_watermark",
    isMobile: false
  }
  componentDidMount() {
    this.drawCanvasResize()
    this.handelWaterClose=(el:any)=>{
     requestAnimationFrame(()=>{
      try{
          if(FTCanvasStore.canvas &&FTCanvasStore.waterMark && this.waterCloseRef&&this.canvasRef){
            let heightGetScacls=FTCanvasStore.canvas.offsetHeight/FTCanvasStore.canvas.height
            let widthGetScacls=FTCanvasStore.canvas.offsetWidth/FTCanvasStore.canvas.width
            let bottoms=FTCanvasStore.canvas.offsetTop + FTCanvasStore.canvas.offsetHeight
            let lefts=FTCanvasStore.canvas.offsetLeft+(FTCanvasStore.waterInfo.x*widthGetScacls)+(FTCanvasStore.waterInfo.width*widthGetScacls)
            this.waterCloseRef.style.left=lefts+'px';
            let waterGap=(FTCanvasStore.canvas.height - FTCanvasStore.waterInfo.y)*heightGetScacls
            this.waterCloseRef.style.top=bottoms-waterGap+'px';
            let doms:HTMLDivElement=this.waterCloseRef.querySelector('.canvas_content_touch') as HTMLDivElement;
            if(doms){
              doms.style.transform=`scale(${widthGetScacls})`
            }
            if(FTImageStore.currentEffect && FTImageStore.currentEffect.name !== "Original" && !FTUserStore.isVip){
              this.waterCloseRef.style.display='flex'
            }
            else{
              this.waterCloseRef.style.display='none'
            }
          }
      }
      catch(error){

      }
     })
    }
    this.observe=new ResizeObserver(this.handelWaterClose)
    this.observe.observe(this.canvasRef as HTMLDivElement)
    autorun(() => {
      let { loading, canvas, ctx, isMobile,hasCompare } = FTCanvasStore
      this.hasCompare=hasCompare
      let { isVip } = FTUserStore
      let { currentEffect, currentIntensity } = FTImageStore
      let waterMarkText = this.getWaterMark()
      this.setState({
        loading,
        showPanel: !!(canvas && ctx),
        showWaterMark: !isVip && currentEffect,
        currentIntensity,
        waterMarkText,
        isMobile,
      }, () => {
        this.drawCnavasResizeTimer()
      })
    })
    // 长按 显示
    // this.canvasRef!.addEventListener("touchstart", this.touchStart, true)
    // this.canvasRef!.addEventListener("touchend", this.touchEnd, true)
    window.addEventListener("resize", this.drawCnavasResizeTimer)
  }
  touchStart = (e: any) => {
    this.imageBlandMaskTimer = setTimeout(async () => {
      FTCanvasStore.downloadImage = await FTCanvasStore.getDownloadImage()
      this.touchEnd()
    }, 800)
  }
  touchEnd = () => {
    clearTimeout(this.imageBlandMaskTimer)
    this.imageBlandMaskTimer = null
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.drawCnavasResizeTimer)
    this.observe?.disconnect()
    // this.canvasRef!.removeEventListener("touchstart", this.touchStart, true)
    // this.canvasRef!.removeEventListener("touchend", this.touchEnd, true)
  }

  getWaterMark = (): string => {
    let { showFreeTry, showDiscount } = FTUserStore
    if(showDiscount !== 0) return "goart_remove_watermark_discount"
    if(showFreeTry) return "goart_remove_watermark_free"
    return "goart_remove_watermark"
  }

  drawCanvasResize = () => {
    if(this.canvasRef && this.canvasContainRef) {
      let { showWaterMark, isMobile } = this.state
      let { currentSize: { width: imgWidth, height: imgHeight} } = FTImageStore
      let { width, height } = this.canvasContainRef.getBoundingClientRect()
      let maxHeight = showWaterMark ? height -  240 : height -  150 ,maxWidth = width - (isMobile ? 0 : 200)
      let scale = 1
      // 根据 canvas 和 父容器的宽高比来设置 缩放大小
      if(imgWidth / width > imgHeight/ height) {
        scale = imgWidth / width
      } else {
        scale = imgHeight / height
      }
      if(!FTCanvasStore.canvas || !FTCanvasStore.ctx) {
        const canvas = document.createElement("canvas")
        canvas.width = imgWidth / scale
        canvas.height = imgHeight / scale
        FTCanvasStore.compareCanvas.width = imgWidth / scale
        FTCanvasStore.compareCanvas.height = imgHeight / scale
        this.canvasRef.style.width = Math.min(canvas.width, maxWidth) + "px"
        this.canvasRef.style.height = Math.min(canvas.height, maxHeight) + "px"
        this.canvasRef.appendChild(FTCanvasStore.compareCanvas)
        this.canvasRef.appendChild(canvas)
        FTCanvasStore.setCanvas(canvas)
      } else {
        FTCanvasStore.canvas.width = imgWidth / scale
        FTCanvasStore.canvas.height = imgHeight / scale
        FTCanvasStore.compareCanvas.width = imgWidth / scale
        FTCanvasStore.compareCanvas.height = imgHeight / scale
        this.canvasRef.style.width = Math.min(FTCanvasStore.canvas.width, maxWidth) + "px"
        this.canvasRef.style.height = Math.min(FTCanvasStore.canvas.height, maxHeight) + "px"
      }
      FTCanvasStore.draw()
    }
  }


  drawerTimer: any = null
  drawCnavasResizeTimer = () => {
    if(this.drawerTimer) {
      cancelAnimationFrame(this.drawerTimer)
      this.drawerTimer = null
    }
    this.drawerTimer = requestAnimationFrame(() => {
      this.drawCanvasResize()
      if(this.handelWaterClose){
        this?.handelWaterClose()
      }
      cancelAnimationFrame(this.drawerTimer)
      this.drawerTimer = null
    })
  }

  removeWaterMark = () => {
    if(FTUserStore.userInfo) {
      !FTUserStore.isVip && FTUserStore.showPaymnet({
        vipType: "vip",
        position: "goart_remove_watermark",
        otherParam: {
          scenesId: "012"
        }
      })
    } else {
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_remove_watermark"
        }, 
        isShowScenses: true,
        otherParam: {
          scenesId: "015",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          this.removeWaterMark()
        }
      })
    }
  }

  downloadFullSize = () => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$try_export$goart_project',
      label: {
        resource_id: FTImageStore.currentEffect ? utils.toFixed(FTImageStore.currentEffect.id, 0) : "original"
      }
    })
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$download$goart_project',
      label: {
        resource_id: FTImageStore.currentEffect ? utils.toFixed(FTImageStore.currentEffect.id, 0) : "original",
        position: "download_fullsize"
      }
    })
    if(!FTImageStore.imageHD) {
      FTCanvasStore.downloadPreview()
      return
    }
    if(!FTUserStore.userInfo) {
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_download_fullsize"
        }, 
        isShowScenses: true,
        otherParam: {
          scenesId: "010",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          this.downloadFullSize()
        }
      })
    } else {
      if(!FTUserStore.isVip) {
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_download_hd",
          otherParam: {
            scenesId: "012"
          },
          callback: () => {
            FTCanvasStore.downloadFullSize()
          }
        })
      } else {
        FTCanvasStore.downloadFullSize()
      }
    }
  }

  prevEffect = () => {
    FTImageStore.prev()
  }

  nextEffect = () => {
    FTImageStore.next()
  }


  sliderTimer: any = null
  onChange = (value: any) => {
    if(this.sliderTimer) {
      cancelAnimationFrame(this.sliderTimer)
      this.sliderTimer = null
    }
    this.sliderTimer = requestAnimationFrame(() => {
      FTImageStore.changeCurrentIntensity(value)
      cancelAnimationFrame(this.sliderTimer)
      this.sliderTimer = null
    })
  }

 handleImageHD=(isSpecail=false) => {
    if(FTCanvasStore.hasShowWater) {
      if(!FTUserStore.userInfo) {
        // 登录
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_close_watermark"
        },
        isShowScenses: true,
        otherParam: {
          scenesId: "010",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          this.handleImageHD(true)
        }
      })
        return
      }
      if(!FTUserStore.isVip) {
        // 升级
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_close_watermark",
          otherParam: {
            scenesId: "012"
          },
          callback: () => {
            this.handleImageHD(true)
          }
        })
        return
      }
    }
    FTImageStore.imageHD = true
  }

  render() {
    let  { loading, showPanel, showWaterMark, currentIntensity, isMobile, waterMarkText } = this.state
    return <div className="canvas" ref={(dom) => { this.canvasContainRef = dom}}>
      {showPanel && <FTCanvasPanel drawCanvasResize={this.drawCanvasResize} download={this.downloadFullSize}/>}
      { <div className="canvas_content" ref={(dom) => { this.canvasRef = dom}}>
        <div style={{display:FTCanvasStore.hasCompare?'none':'flex'}} ref={(dom)=>{this.waterCloseRef=dom}} className="canvas_content_water">
        <div onClick={()=>{
          this.handleImageHD()
        }} className="canvas_content_touch">
        <div className="canvas_content_svg">
          <IconClose width={8}/>
          </div>
            </div>
        </div>
        {/* 新迭代不需要左右切换了，逻辑要复杂的多 */}
        { false && FTImageStore.hasPrev() && !isMobile && <Popover content={FTLang._("goart_pre")}>
              <div className="canvas_left" onClick={() => this.prevEffect()}>
                <IconArrawLeft />
              </div>
            </Popover>}
        { false && FTImageStore.hasNext() && !isMobile && <Popover content={FTLang._("goart_next")}>
              <div className="canvas_right" onClick={() => this.nextEffect()}>
                <IconArrawRight />
              </div>
            </Popover>}
      </div>}
      {
        FTImageStore.currentEffect && isMobile && <div className="canvas_extra_operate">
          <FTimageHD needToolTip={false}/>
          <FTDownloadSize theme="dark" />
          <FTimageCompare theme="dark" needToolTip={false}/>
        </div>
      }
      {
        FTImageStore.currentEffect && !isMobile && <div className="canvas_extra_HD">
          <FTimageHD needToolTip={true}/>
        </div>
      }

      {FTImageStore.currentEffect && <div className={`canvas_extra ${isMobile ? "canvas_extra_mobile" : ""}`}>
        <div style={{marginBottom:isMobile?'0':'28px'}}>
          <div style={{opacity:!FTImageStore.currentEffect?.aigc?1:0}} className={`canvas_extra_intensity ${isMobile ? "canvas_extra_intensity_mobile" : ""}`}>
            {!FTImageStore.currentEffect?.aigc&&<>
              <span className="canvas_extra_intensity_text">{FTLang._("goart_strong")}</span>
            {!FTImageStore.currentEffect?.aigc&& <Slider
              min={FTImageStore.intensity.min}
              max={FTImageStore.intensity.max}
              onChange={this.onChange}
              value={currentIntensity}
            />}
            <InputNumber
              className="canvas_extra_intensity_input"
              controls={false}
              min={FTImageStore.intensity.min}
              max={FTImageStore.intensity.max}
              onChange={this.onChange}
              value={currentIntensity}
            /></>}
          </div>
          {!isMobile && <FTimageCompare theme="light" needToolTip={true} placement="top" />}
        </div>
        {showWaterMark && !isMobile && <div className="canvas_extra_remove">
          <FTWatermark />
        </div>}
      </div>}
      {loading && <div className="canvas_loading">
        <div className="canvas_loading_mask">
          <img src={CanvasLoading} alt="" />
          <span>{FTLang._("goart_open_loading")}</span>
        </div>
      </div>}
    </div>
  }
}

export default FTCanvas
